import { z } from "zod";

export enum SchedulingLinkIntent {
  Initial = "initial",
  FollowUp = "follow_up",
  Reschedule = "reschedule",
}

export const schedulingLinkIntentSchema = z.enum(SchedulingLinkIntent);

export enum SchedulingLinkResultStatus {
  Sent = "sent",
  Unavailable = "unavailable",
}

export enum SchedulingLinkOpportunityStatus {
  Control = "control",
  /** Treatment send started; the call continues while its outcome is unknown. */
  Pending = "pending",
  Sent = "sent",
  Unavailable = "unavailable",
}

export enum SchedulingLinkUnavailableReason {
  ActiveConversation = "active_conversation",
  ConsentUnverified = "consent_unverified",
  MissingConsent = "missing_consent",
  MissingPhone = "missing_phone",
  OptedOut = "opted_out",
  SendFailed = "send_failed",
  Unsupported = "unsupported",
}

export const schedulingLinkRequestSchema = z.object({
  groupId: z.string().uuid(),
  patientId: z.string().uuid(),
  requestId: z.string().min(1).max(200),
  intent: schedulingLinkIntentSchema,
  /** Optional until every live voice agent sends it; booking links without it carry no invite. */
  eligiblePractitionerIds: z.array(z.string().uuid()).min(1).optional(),
  /** Exact Valerie appointment approved by Voice eligibility for a rescheduling handoff. */
  sourceAppointmentId: z.string().uuid().optional(),
});

export const schedulingLinkResponseSchema = z.discriminatedUnion("status", [
  z.object({ status: z.literal(SchedulingLinkResultStatus.Sent), messageId: z.string().uuid() }),
  z.object({
    status: z.literal(SchedulingLinkResultStatus.Unavailable),
    reason: z.enum(SchedulingLinkUnavailableReason),
  }),
]);

export type SchedulingLinkRequest = z.infer<typeof schedulingLinkRequestSchema>;
export type SchedulingLinkResponse = z.infer<typeof schedulingLinkResponseSchema>;
